import { GAME_KIND_PARAM } from '../game/gameKindCache';

/** What the next load cannot read from a tab that stores nothing: that the game is a custom pack, and the session. */
export interface LabAddressCarry {
  sessionToken: string | null;
}

/**
 * The lab's page for game `gameId`, built from the address of whatever page the player is on. The game is set
 * outright, never assumed to be in the address already: a swipe or a demo link leaves another one there. The
 * rest of the query (embed, session and theme parameters, the order being opened) travels along as it came.
 * With `carry`, the address also names the game's kind and gives back the session the boot took out of it.
 */
export function customPackLabUrl(href: string, gameId: string, carry?: LabAddressCarry): string {
  const url = new URL(href);
  url.pathname = '/';
  url.searchParams.set('game_id', gameId);
  if (carry) {
    url.searchParams.set(GAME_KIND_PARAM, 'custom_pack');
    if (carry.sessionToken) url.searchParams.set('session_token', carry.sessionToken);
  }
  return url.toString();
}
